import {
  getPropertyList,
  getPropertyMasterList,
  getPropertyTemplate,
  createProperty,
  createPropertyMaster,
  getPropertyMasterTemplate,
  editProperty,
  viewProperty,
  deleteProperty,
  editPropertyMaster,
  viewPropertyMaster,
  deletePropertyMaster,
} from "@/http/setup/propertyDefinition";

export default {
  namespaced: true,
  state: {
    propertyList: null,
    propertyMasterList: null,
    propertyTemplate: null,
    propertyMasterTemplate: null,
    propertyView: null,
    propertyMasterView: null,
  },
  actions: {
    async getPropertyListAction({ commit }) {
      const resp = await getPropertyList();
      commit("SET_PROPERTY_LIST", resp.data);
      return resp;
    },
    async viewPropertyAction({ commit }, data) {
      const resp = await viewProperty(data);
      commit("VIEW_PROPERTY", resp.data);
      return resp;
    },
    async viewPropertyMasterAction({ commit }, data) {
      const resp = await viewPropertyMaster(data);
      commit("VIEW_PROPERTY_MASTER", resp.data);
      return resp;
    },
    async getPropertyMasterListAction({ commit }) {
      const resp = await getPropertyMasterList();
      commit("SET_PROPERTY_MASTER_LIST", resp.data);
      return resp;
    },
    async getPropertyTemplateAction({ commit }) {
      const resp = await getPropertyTemplate();
      commit("SET_PROPERTY_TEMPLATE", resp.data);
      return resp;
    },
    async getPropertyMasterTemplateAction({ commit }) {
      const resp = await getPropertyMasterTemplate();
      commit("SET_PROPERTY_MASTER_TEMPLATE", resp.data);
      return resp;
    },
    async createPropertyAction(_, payload) {
      const resp = await createProperty(payload);
      return resp;
    },
    async editPropertyAction(_, payload) {
      const resp = await editProperty(payload.id, payload.data);
      return resp;
    },
    async editPropertyMasterAction(_, payload) {
      const resp = await editPropertyMaster(payload.id, payload.data);
      return resp;
    },
    async createPropertyMasterAction(_, payload) {
      const resp = await createPropertyMaster(payload);
      return resp;
    },
    async deletePropertyAction(_, payload) {
      const resp = await deleteProperty(payload);
      return resp;
    },
    async deletePropertyMasterAction(_, payload) {
      const resp = await deletePropertyMaster(payload);
      return resp;
    },
  },
  mutations: {
    SET_PROPERTY_LIST(state, payload) {
      state.propertyList = payload;
    },
    SET_PROPERTY_MASTER_LIST(state, payload) {
      state.propertyMasterList = payload;
    },
    SET_PROPERTY_MASTER_TEMPLATE(state, payload) {
      state.propertyMasterTemplate = payload;
    },
    SET_PROPERTY_TEMPLATE(state, payload) {
      state.propertyTemplate = payload;
    },
    VIEW_PROPERTY(state, payload) {
      state.propertyView = payload;
    },
    VIEW_PROPERTY_MASTER(state, payload) {
      state.propertyMasterView = payload;
    },
  },
};
